import React from 'react';

import { IMain } from '../types/IMain';

import Header from '../header/header';

import './main.scss';

const Main: React.FC<IMain> = ({
                                 className,
                                 title,
                                 additionalTitle,
                                 investors,
                                 investorDropdown,
                                 onInvestorChange,
                                 children,
                               }) => {
  return (
    <div className={`main-wrapper ${className ? className : ''}`}>
      {title && (
        <Header
          title={title}
          investors={investors}
          additionalTitle={additionalTitle}
          investorDropdown={investorDropdown}
          onInvestorChange={onInvestorChange}
        />
      )}
      {children}
    </div>
  );
};

export default Main;
